export enum ClipStatus {
  NEW = 'NEW',
  INITIALIZING = 'INITIALIZING',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR',
  READY = 'READY',
  CANCELING = 'CANCELING',
  CANCELED = 'CANCELED',
}